import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { utagLinkPDP } from 'features/tealium';
import scrollToSection from 'pages/product/desktop/scrollToSection';

import { fetchProductQuestions } from '../slice';

import './ProductQuestionsAndAnswersPaginationList.scss';

function getPagination (initialCurrentPageNumber, initialPageCount, defaultPageLinkCount = 5) {

	const pagination = {
		currentPageNumber: initialCurrentPageNumber,
		pageCount: initialPageCount,
		pageList: []
	};

	if (initialPageCount <= 1) {

		return pagination;

	}

	const pageNumbersToRender = [];

	const pageLinkCount = defaultPageLinkCount;
	const pageGroupCount = pageLinkCount - 2;
	const firstPageGroupMaxNumber = initialPageCount <= pageLinkCount ? initialPageCount : pageGroupCount;
	let lastPageGroupMinNumber = initialPageCount > pageLinkCount ? initialPageCount - pageGroupCount : 0;

	const isCurrentPageInFirstGroup =		initialCurrentPageNumber <= firstPageGroupMaxNumber || initialPageCount <= pageLinkCount;
	const isCurrentPageInTheMiddle =		initialCurrentPageNumber >= firstPageGroupMaxNumber && initialCurrentPageNumber <= lastPageGroupMinNumber;
	const isCurrentPageInLastGroup = initialCurrentPageNumber > lastPageGroupMinNumber && lastPageGroupMinNumber > 0;

	if (isCurrentPageInFirstGroup) {

		const firstPageLimit = initialPageCount <= pageLinkCount ? initialPageCount : pageLinkCount - 1;

		for (let i = 1; i <= firstPageLimit; i += 1) {

			pageNumbersToRender.push(i);

		}
		if (initialPageCount > pageLinkCount) {

			pageNumbersToRender.push(initialPageCount);
			pagination.showLastPageEllipsis = true;

		}

	} else if (isCurrentPageInLastGroup) {

		while (lastPageGroupMinNumber > 0 && lastPageGroupMinNumber <= initialPageCount) {

			pageNumbersToRender.push(lastPageGroupMinNumber);
			lastPageGroupMinNumber += 1;
			if (pageNumbersToRender.Count > pageLinkCount) {

				break;

			}

		}
		pagination.showFirstPageEllipsis = true;
		pageNumbersToRender.splice(0, 0, 1);

	} else if (isCurrentPageInTheMiddle) {

		const middleLinkCount = pageLinkCount - 2;
		const middleStartNumber = Math.floor(middleLinkCount / 2);
		let middlePageNumber = initialCurrentPageNumber - middleStartNumber;

		for (let i = 0; i < middleLinkCount; i += 1) {

			if (middlePageNumber < initialPageCount) {

				pageNumbersToRender.push(middlePageNumber);

			}
			middlePageNumber += 1;

		}
		pagination.showFirstPageEllipsis = true;
		pagination.showLastPageEllipsis = true;
		pageNumbersToRender.splice(0, 0, 1);
		pageNumbersToRender.push(initialPageCount);

	}

	pagination.pageList = pageNumbersToRender;

	return pagination;

}

const ProductQuestionsAndAnswersPaginationList = () => {

	const { sortOrder, pageNumber, pageCount } = useSelector((state) => state.productQuestionsAndAnswers);
	const pagination = getPagination(pageNumber, pageCount);

	const dispatch = useDispatch();

	const handlePageChange = (event, page) => {

		const fetchParameters = {
			pageNumber: page,
			pageSize: page > 1 ? 10 : 3,
			sortOrder
		};

		dispatch(fetchProductQuestions(fetchParameters));

		const buttonLabel = event.currentTarget.attributes['aria-label'];
		let paginationLabel;
		if (buttonLabel && buttonLabel.value === 'Previous') {

			paginationLabel = '<';

		} else if (buttonLabel && buttonLabel.value === 'Next') {

			paginationLabel = '>';

		} else {

			paginationLabel = event.currentTarget.innerHTML;

		}
		utagLinkPDP('TurnTo')({
			eventAction: 'Q&A-Click-Page',
			eventLabel: `${window.shortSku}-${paginationLabel}`
		});
		scrollToSection('.jsProductQuestionsAndAnswersContainer');

	};

	const prevBtnDiasable = pageNumber === 1;
	const nextBtnDiasable = pageNumber === pageCount;

	return (
		<div className="ProductQuestionsAndAnswersPaginationList">
			<ul className="ProductQuestionsAndAnswersPaginationList__listContainer">
				<li className="ProductQuestionsAndAnswersPaginationList__list">
					<button
						type="button"
						className={classNames('ProductQuestionsAndAnswersPaginationList__arrow lpIcon-scrollleft', {
							disabled: prevBtnDiasable
						})}
						disabled={prevBtnDiasable}
						aria-disabled={prevBtnDiasable}
						aria-label="Previous"
						onClick={(event) => handlePageChange(event, pageNumber - 1)}
					/>
				</li>

				{pagination.pageList.map((pageNo) => (
					<li
						key={pageNo}
						className={classNames('ProductQuestionsAndAnswersPaginationList__list', {
							ProductQuestionsAndAnswersPaginationList__first:
								pagination.showFirstPageEllipsis && pageNo === 1 && pagination.pageCount > 3,
							ProductQuestionsAndAnswersPaginationList__last:
								pagination.showLastPageEllipsis
								&& pageNo === Number(pagination.pageCount)
								&& pagination.pageCount > 3,
							ProductQuestionsAndAnswersPaginationList__current: pagination.currentPageNumber === pageNo
						})}
					>
						<button
							type="button"
							className="ProductQuestionsAndAnswersPaginationList__pageButton"
							onClick={(event) => handlePageChange(event, pageNo)}
						>
							{pageNo}
						</button>
					</li>
				))}

				<li className="ProductQuestionsAndAnswersPaginationList__list">
					<button
						type="button"
						className={classNames('ProductQuestionsAndAnswersPaginationList__arrow lpIcon-scrollright', {
							disabled: nextBtnDiasable
						})}
						disabled={nextBtnDiasable}
						aria-disabled={nextBtnDiasable}
						aria-label="Next"
						onClick={(event) => handlePageChange(event, pageNumber + 1)}
					/>
				</li>
			</ul>
		</div>
	);

};

export default ProductQuestionsAndAnswersPaginationList;
